// extracted by mini-css-extract-plugin
export default {"container":"close-full-screen_container__eqeWD"};